module.exports = __webpack_public_path__ + "static/media/2.0fe130e8.jpg";